var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantages4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 58.3334H37.5C37.5 48.3878 41.4509 38.8495 48.4835 31.8169C55.5161 24.7843 65.0544 20.8334 75 20.8334V29.1667C58.875 29.1667 45.8333 42.2084 45.8333 58.3334ZM75 45.8334V37.5C63.5 37.5 54.1666 46.8334 54.1666 58.3334H62.5C62.5 51.4167 68.0833 45.8334 75 45.8334ZM29.1666 16.6667C29.1666 12.0417 25.4583 8.33337 20.8333 8.33337C16.2083 8.33337 12.5 12.0417 12.5 16.6667C12.5 21.2917 16.2083 25 20.8333 25C25.4583 25 29.1666 21.2917 29.1666 16.6667ZM47.7083 18.75H39.375C38.8994 21.6643 37.4008 24.3137 35.1481 26.2227C32.8954 28.1318 30.0361 29.1755 27.0833 29.1667H14.5833C11.125 29.1667 8.33331 31.9584 8.33331 35.4167V45.8334H33.3333V36.4167C37.1911 35.1945 40.6073 32.8709 43.1614 29.732C45.7155 26.593 47.296 22.7757 47.7083 18.75ZM79.1666 70.8334C83.7916 70.8334 87.5 67.125 87.5 62.5C87.5 57.875 83.7916 54.1667 79.1666 54.1667C74.5416 54.1667 70.8333 57.875 70.8333 62.5C70.8333 67.125 74.5416 70.8334 79.1666 70.8334ZM85.4166 75H72.9166C66.6666 75 61.625 70.5 60.625 64.5834H52.2916C53.125 72.9167 58.9166 79.7917 66.6666 82.25V91.6667H91.6666V81.25C91.6666 77.7917 88.875 75 85.4166 75Z",
    fill: "url(#paint0_linear_303_147)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_147",
    x1: 1.74153,
    y1: 100.464,
    x2: 91.5716,
    y2: 4.54106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantages4);
export default __webpack_public_path__ + "static/media/advantages_4.7a3ab53ec3faed9ba82aa5a1c9585168.svg";
export { ForwardRef as ReactComponent };